module.exports = __webpack_public_path__ + "img/231.2f875fa7.svg";